import React, { useEffect } from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Order } from '../../../../app/services/api/orderManagementClient';
import useCurrencyCodeConfiguration from '../../../../hooks/configurations/useCurrencyCodeConfiguration';
import { applyRoundAndFormat } from '../../../../utils';

interface WorstPerformingProductsProps {
  orders: Order[];
}

const WorstPerformingProducts = ({ orders }: WorstPerformingProductsProps) => {
  const theme = useTheme();
  const { currencyCode, getCurrencyCodeConfiguration } = useCurrencyCodeConfiguration();

  useEffect(() => {
    getCurrencyCodeConfiguration();
  }, []);

  // Aggregate sales by product (using orderType as a stand-in for product, replace with real product info if available)
  const productTotals: { [product: string]: number } = {};
  orders.forEach(order => {
    productTotals[order.orderType] = (productTotals[order.orderType] || 0) + (order.totalCost || 0);
  });
  const sorted = Object.entries(productTotals)
    .sort((a, b) => a[1] - b[1])
    .slice(0, 5);

  return (
    <List style={{ height: 200, color: theme.palette.text.primary, fontSize: theme.typography.textSM.fontSize }}>
      {sorted.map(([product, total]) => (
        <ListItem key={product}>
          <ListItemText
            style={{ color: theme.palette.text.primary, fontSize: theme.typography.textSM.fontSize }}
            primary={product}
            secondary={`Value: ${applyRoundAndFormat(total / 1000, currencyCode)}k`}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default WorstPerformingProducts;